import { useQuery } from '@tanstack/react-query';

import type { CampaignScheduleImportCandidatesResponse } from '~/components/Offers/Detail/OfferBuilder/DealInformation/tabs/campaignSchedules/types';

import OffersService from '~/services/OffersService';

import { offerQueryKeys } from './useGetOffer';

export function useGetCampaignScheduleImportCandidates(
  offerId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: offerQueryKeys.campaignScheduleImportCandidates(offerId),
    queryFn: async ({ signal }) => {
      if (!offerId) {
        throw new Error('offerId is required');
      }

      return (await OffersService.getCampaignScheduleImportCandidates(offerId, {
        signal,
      })) as CampaignScheduleImportCandidatesResponse;
    },
    enabled: enabled && !!offerId,
  });
}
